/**
 * matchEndPostGame — Post-game rematch / lobby return action ids (SPY-215).
 */

export const MATCH_END_POST_GAME_ACTIONS = Object.freeze({
  rematch: Object.freeze({
    id: 'rematch',
    label: 'Rematch',
    restartsTelemetry: true
  }),
  lobby: Object.freeze({
    id: 'lobby',
    label: 'Return to lobby',
    restartsTelemetry: true
  })
});

/**
 * @param {string} actionId
 * @returns {{ id: string, label: string, restartsTelemetry: boolean }|null}
 */
export function resolveMatchEndPostGameAction(actionId) {
  if (!actionId || typeof actionId !== 'string') return null;
  return MATCH_END_POST_GAME_ACTIONS[actionId] || null;
}
